<template>
  <div class="pageDiscount"
   @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent" >
    <XR-head titleText="今日优惠" :rightShow="true"></XR-head>
    <div class="banner">
      <img src=" ../static/discount/banner.png" alt="">
    </div>
    <div class="activityList">
      <mu-tabs :value="activeTab" class="activityListTab" :style="{width:activeTabItemWidth+'px'}" @change="handleTabChange">
        <mu-tab :value="discountItem.ActivityId" :title="discountItem.StartTimeShowName" 
          class="activityTab" :titleClass="activeTab == discountItem.ActivityId?'tabTitle select':'tabTitle'" icon=":fa fa-time2" 
          :iconClass="activeTab == discountItem.ActivityId?'tabIcon select':'tabIcon'" v-for="discountItem in discountList" :key="discountItem.ActivityId"/>   
      </mu-tabs>
    </div>
    <template v-for="item in discountList" >
      <div v-if="activeTab === item.ActivityId" :key="item.ActivityId" >      
        <div class="activity-main">
          <div class="activity-products" style="display: block;">
            <div class="activity-countdown">
              <div class="Spike">
                  <img src=" ../static/discount/1.png" alt="">
              </div>
              <div class="countdown">
                <span class="desc">{{calcDesc}}</span>
                <span class="time hour1">{{hour1}}</span>
                <span class="time hour2">{{hour2}}</span>
                <span class="font">时</span>
                <span class="time minute1">{{mm1}}</span>
                <span class="time minute2">{{mm2}}</span>
                <span class="font">分</span>
                <span class="time secend1">{{ss1}}</span>
                <span class="time secend2">{{ss2}}</span>
                <span class="font">秒</span>
              </div>
            </div>
            <mu-divider></mu-divider>
            <div class="product  " v-for="productItem in item.Products" :key="productItem.SkuId">
              <img :src="productItem.ImgPath?productItem.ImgPath:IMGServer_URL+'/images/index-item-default.png'" class="discount-pro-img">
              <div class="info" :style="{width:fullProductInfoWidth+'px'}">                
                <p class="name">{{productItem.ProductName}}</p>
                <span class="desc"></span>
                <div class="row">
                  <p class="price">
                    <span class="discount-price">￥{{productItem.DiscountPrice.toFixed(2)}}</span>
                    <span cass="red">元</span>
                  </p>              
                  <div class="btn">
                    <router-link :to="'/retail/productDetail?skuId='+productItem.SkuId"><mu-raised-button secondary class="btn-text" style="width:75px">去秒杀</mu-raised-button></router-link>
                  </div>
                </div>
                <div class="row">
                  <span class="delete-price">￥{{productItem.Price.toFixed(2)}}</span>
                  <div class="stockProcess">                
                    <span class="text" v-if="productItem.BuyCount == productItem.Stock">已秒完</span>
                    <mu-linear-progress mode="determinate" class="process" style="width:88px" :value="productItem.BuyCount/productItem.Stock*100"/>
                  </div>
                </div>
              </div>
            </div>
            <mu-divider></mu-divider>
          </div>
        </div>
      </div>
    </template>
    
    <div class="xr-bottom">        
      <mu-paper class="bottom-nav">
        <mu-bottom-nav :value="bottomNav" shift @change="handleChange">
          <mu-bottom-nav-item to="/active/discount" value="index" title="限时抢购" icon=":fa fa-myshizhong4"/>
          <mu-bottom-nav-item to="/active/tosellout" value="category" title="即将抢光" icon=":fa fa-myshizhong3"/>
          <mu-bottom-nav-item to="/active/tomorrow" value="discount" title="明日预告" icon=":fa fa-myshizhong2"/>
          <mu-bottom-nav-item to="/usercenter/index" value="bugcart" title="个人中心" icon=":fa fa-liangren"/>
        </mu-bottom-nav>    
      </mu-paper>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
</div>
</template>

<script>
export default {
  data(){
    return {
      fullProductInfoWidth: document.documentElement.clientWidth-115,
      fullProcessWidth : document.documentElement.clientWidth-115-80-50,
      discountList:[],
      activeTab:0,
      startTime :'',
      endTime:'',
      nowTime:'', //服务器当前时间，为了防止本地时间与服务器时间不一致
      buynowInterval :0,
      calcDesc:'距开始',
      hour1:'0',
      hour2:'0',
      mm1:'0',
      mm2:'0',
      ss1:'0',
      ss2:'0',
			bottomNav: "",
      bottomNavColor: "",
      timeSpace:0,//时间差
      isGetTimeSpace:false,//是否已设置时间差
    }
  },
  mounted () {    
    var path = this.$route.path
    if(path == '/active/discount'){
      this.bottomNav = 'index'
    }else if(path=='/active/tosellout'){
      this.bottomNav= 'category'
    }else if(path=='/active/tomorrow'){
      this.bottomNav= 'discount'
    }

    this.getDiscountPage()
  },
  computed:{
    activeTabWidth:function(){
      var count =  this.discountList.length % 4 !=0 ?this.discountList.length / 4  +1:   this.discountList.length / 4 
      return count *  document.documentElement.clientWidth
    },    
    activeTabItemWidth:function(){
      var length =  document.documentElement.clientWidth / 4.5 * this.discountList.length      
      return length
    }
  },
  methods:{
    touchEvent (){
          var scrollTop = document.documentElement.scrollTop
          var imgHeigth= 300+65 
          var opacityValue=scrollTop/imgHeigth
          document.querySelector('.mu-appbar').style.background='rgba('+this.themeColor+','+opacityValue+')'
      }, 
		handleChange(val) {
        this.bottomNav = val;
        if (this.bottomNav == "优惠") {
          this.$router.push("/usercenter/coin");
        }
      },
    handleTabChange(val){      
      this.startTime = '';
      this.endTime = '';      
      this.hour1='0'
      this.hour2='0'
      this.mm1='0'
      this.mm2='0'
      this.ss1='0'
      this.ss2='0'
      this.activeTab = val
      clearInterval(this.buynowInterval);
      this.buynowInterval = setInterval(this.countdownEvent, 1000);
    },
    getDiscountPage(){
      const ths = this;
      this.$post("/Shop/RetailServer/GetActivityDiscountTodayProduct")
      .then(function(res) {
        if (res.IsSuccess) {
          if(res.Data.length ==0)
          {
            ths.$refs.XRPageTip.ShowEmpty('暂无更多活动')
          }
          ths.loaded = false
          ths.discountList = res.Data
          ths.activeTab = res.Data[0].ActivityId
          clearInterval(ths.buynowInterval);
          ths.buynowInterval = setInterval(ths.countdownEvent, 1000);
          ths.$refs.XRtoast.hide()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },  
    countdownEvent : function () {
        var activityEntity = {}
        for(var i = 0; i< this.discountList.length; i++){
          var tmpActivity = this.discountList[i];
          if(tmpActivity.ActivityId == this.activeTab){
            activityEntity = tmpActivity;
            break;
          }
        }
        this.nowTime = activityEntity.NowTimeName
        if(activityEntity.Status == 0){
          this.startTime = activityEntity.StartTimeName;
          this.calcDesc = "距开始"
        }
        else if(activityEntity.Status == 1){
          this.endTime = activityEntity.EndTimeName;
          this.calcDesc = "距结束"
        }

        if(!this.isGetTimeSpace){
          this.isGetTimeSpace = true          
          this.timeSpace = (new Date()) - (new Date(this.nowTime))
        }

        //结束倒计时
        if (this.endTime) {
            var ts = (new Date(this.endTime)) - (new Date()) + this.timeSpace; //计算剩余的毫秒数    
            if (ts <= 0) {
                this.getDiscountPage();
                return;
            }
            this.calcTime(ts);
            return;
        }

        //开始倒计时
        var startTime = this.startTime;
        if (startTime) {
            var ts = (new Date(startTime)) - (new Date()) + this.timeSpace; //计算剩余的毫秒数    
            if (ts <= 0) {
                this.getDiscountPage();
                return;
            }
            this.calcTime(ts);
            return;
        }
    },
    calcTime : function (ts) {
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数  

        this.hour1 = parseInt(hh / 10);
        this.hour2 = hh % 10;
        this.mm1 = parseInt(mm / 10);
        this.mm2 = mm % 10;
        this.ss1 = parseInt(ss / 10);
        this.ss2 = ss % 10;
    },
  }
}

</script>

<style>
#app .pageDiscount{
  bottom:unset;
  padding-bottom: 70px;
}
.pageDiscount .XR-head{
    position: fixed;
    background: rgb(0,0,0,0);
    box-shadow: none;
  }
.pageDiscount .XR-head .left .mu-icon-button .fa-angle-left {
  background: rgba(71,74,79,0.25);
  border-radius: 50%;
}
.pageDiscount .XR-head .right .mu-icon-button .fa-mymore {
  background: rgba(71,74,79,0.25);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  line-height: 26px;
  font-size: 18px;
}
.pageDiscount .XR-head .mu-appbar-title span {
  background: rgba(71,74,79,0.25);
  padding: 3px 6px;
  color: #fff;
}
.pageDiscount .tabIcon.select{ color:red;}
.pageDiscount .tabTitle.select{ color:red;}
.pageDiscount .banner{
  width: 100%;
  height: 120px;
  margin-bottom: 1px;
}
.pageDiscount .banner img{
  width: 100%;
  display: block;
  height: 100%;
}
.pageDiscount  .activity-countdown { width:100%; height:55px;padding: 0 10px;}
.pageDiscount  .activity-countdown .Spike{width: 100px;height: 55px;float: left;}
.pageDiscount  .activity-countdown .Spike img{width: 100%;object-fit: cover;margin-top: 9px;}
.pageDiscount  .activity-countdown .countdown {  margin:0 auto;  height:55px; display: flex;align-items: center; float: right;}
.pageDiscount  .activity-countdown .countdown span { float:left; height:23px; line-height:23px; color:#666;}
.pageDiscount  .activity-countdown .countdown .desc { margin-right:5px;}
.pageDiscount  .activity-countdown .countdown .font { font-size:12px; width:14px; text-align:center; color:#666;}
.pageDiscount  .activity-countdown .countdown .time { font-size:18px; width:14px; height:23px; text-align:center; background:url(/static/active/countdown.png) no-repeat; color:white;}

.pageDiscount  .activity-products { width:100%; overflow:hidden; background:white;}
.pageDiscount  .activity-products .product { width:100%; overflow:hidden; padding:20px 10px; position:relative;}
.pageDiscount  .activity-products .product .discount-pro-img { width:85px; float:left; display: block;}
.pageDiscount  .activity-products .product .info { float:right; overflow:hidden;}
.pageDiscount  .activity-products .product .info .name { height:24px; line-height:24px; color:black; font-size:14px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
.pageDiscount  .activity-products .product .info .desc { display:block; height:15px; line-height:15px; overflow:hidden; font-size:12px; color:#666; margin-bottom: 10px;}
.pageDiscount  .activity-products .product .info .row {}
.pageDiscount  .activity-products .product .info .row .price { overflow:hidden; height:20px; line-height:20px;}
.pageDiscount  .activity-products .product .info .row .price .discount-price { font-size:20px; color:Red;}
.pageDiscount  .activity-products .product .info .row .price .red { color:Red; font-size:12px;}
.pageDiscount  .activity-products .product .info .row .btn {  cursor:pointer; overflow: hidden;}
.pageDiscount  .activity-products .product .info .row .btn .btn-text { font-size: 12px; float:right;  height:24px; line-height:24px; text-align:center; padding:0 5px;}
.pageDiscount  .activity-products .product .info .row .btn .btn-text.unable {border:1px solid #ccc;}

.pageDiscount  .activity-products .product .info .row .delete-price { float: left; width:80px; font-size:12px; line-height: 24px; color:#999; text-decoration:line-through;}
.pageDiscount  .activity-products .product .info .row .stockProcess{ float: left;}
.pageDiscount  .activity-products .product .info .row .stockProcess .process{ float: left; margin: 9px 0;}
.pageDiscount  .activity-products .product .info .row .stockProcess .text{ width: 50px; float: left; text-align: right; line-height: 24px; font-size: 12px;}
.pageDiscount .xr-bottom { position:fixed; height:70px; width:100%; bottom:0; background:#EEEEEE;z-index: 999;}
.pageDiscount .xr-bottom .bottom-nav .mu-bottom-item-icon{font-size: 26px;width: 30px;}

.pageDiscount .activity-nav-fix .nav { width:25%; height:64px; float:left; padding:13px 0 0;}
.pageDiscount .activity-nav-fix .nav img { width:27px; display:block; margin:0 auto;}
.pageDiscount .activity-nav-fix .nav .text { line-height:18px; height:18px; margin-top:4px; margin-bottom:8px; display:block; text-align:center;color:#8b8d8c;}
.pageDiscount .activity-nav-fix .nav.active .text { color:Red;}

.pageDiscount .yingxiao.youpin .pro-list .item .price .del { line-height:32px;}


.pageDiscount .activityList{
  width:100%;
  overflow-x:scroll;
  overflow-y: hidden;
  background: #474a4f;
}
.pageDiscount .activityListTab{
  height: 52px;
}
.pageDiscount .activityListTab .activityTab{
  padding: 5px 0;
}
.pageDiscount .activityListTab .activityTab .fa-time2{
  font-size: 20px;
}
.pageDiscount .activityListTab .activityTab .mu-tab-text.has-icon{
  margin: 0;
  line-height: 15px;
}
.pageDiscount  .xr-pageTip{
  top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/pages/active/discount.vue